import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import { chunk } from "lodash";

export default function RenderGridLabel({ data, isShowLabel }) {
  const map = useMap();
  const currentLayer = useRef(null);
  const mainFeatureGroup = L.featureGroup();

  useEffect(() => {
    if (currentLayer.current) {
      currentLayer.current.clearLayers();
    }

    if (!isShowLabel || !data) {
      return;
    }

    const componentLabelChunk = chunk(data, 10);

    componentLabelChunk.forEach((componentLabels) => {
      componentLabels.forEach((label) => {
        const coordinate = label.geometry_json.coordinates;
        const html =
          '<span style="color: #000000; font-size: 11px !important;">' +
          label.string +
          "</span>";
        const myIcon = L.divIcon({
          className: "node-label-text",
          style: { minWidth: 50 },
          html: html,
        });
        const marker = L.marker(coordinate, { icon: myIcon });

        mainFeatureGroup.addLayer(marker);
      });
    });

    mainFeatureGroup.addTo(map);
    currentLayer.current = mainFeatureGroup;
  }, [data, isShowLabel]); // eslint-disable-line

  return null;
}
